import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useAddSeriesGroupModalViewModel = ({
  setRefresh,
  handleCloseModal,
}) => {
  const stateManager = useComponentState();

  const handleCreateSeriesGroup = (data) => {
    stateManager.run(async () => {
      const response = await homeService.seriesGroup.create({
        data,
        toastMessageConfig: {
          success: {
            text: `Successfully created Series Group: ${data.name}.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        handleCloseModal();
        setRefresh((prev) => !prev);
      }
    });
  };

  const handleUpdateSeriesGroup = (data) => {
    stateManager.run(async () => {
      const response = await homeService.seriesGroup.update({
        data,
        toastMessageConfig: {
          success: {
            text: `Successfully updated Series Group: ${data.name}.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        handleCloseModal();
        setRefresh((prev) => !prev);
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    handleCreateSeriesGroup,
    handleUpdateSeriesGroup,
  };
};
